import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"
import _imports_0 from '@/assets/deleteIcon.svg'


const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_2 = { class: "flex items-center justify-center w-full h-16 skeleton mt-4 tableCornerRadius bg-white" }
const _hoisted_3 = {
  key: 1,
  class: "table-data-root"
}
const _hoisted_4 = { class: "tableCornerRadius bg-white table-card-shell" }
const _hoisted_5 = { class: "table-container table-container-fit" }
const _hoisted_6 = { class: "table-header-wrap" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onMousedown"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = { class: "table-body-scroll" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_27 = ["colspan"]
const _hoisted_28 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_29 = { class: "cursor-pointer rowHeight" }
const _hoisted_30 = ["colspan"]
const _hoisted_31 = {
  key: 2,
  class: "nonEmptyTable"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 0,
  style: {"white-space":"break-spaces"}
}
const _hoisted_36 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_37 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { key: 3 }
const _hoisted_40 = {
  key: 2,
  class: "flex justify-center"
}
const _hoisted_41 = ["onMousemove"]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 3 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 4 }
const _hoisted_47 = { key: 5 }
const _hoisted_48 = { key: 6 }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { key: 7 }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 2 }
const _hoisted_54 = { key: 3 }
const _hoisted_55 = { key: 8 }
const _hoisted_56 = ["onMousemove"]
const _hoisted_57 = { key: 9 }
const _hoisted_58 = { class: "table-ellipsis" }
const _hoisted_59 = ["onMousemove"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dotsloader = _resolveComponent("dotsloader")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_ctx.dotsLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_dotsloader)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.pageData!=undefined && _ctx.pageData == 4 ? 'fixHeightTable flex flex-col justify-between':'table-card-inner')
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", {
                  class: "table-fit-card table-header-table",
                  style: _normalizeStyle(_ctx.tableResizeStyle)
                }, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn) => {
                        return (_openBlock(), _createElementBlock("th", {
                          scope: "col",
                          key: presentColumn,
                          class: _normalizeClass([[_ctx.getColumnHeadWidth(presentColumn), _ctx.isCenterAlignedColumn(presentColumn) ? 'column-center' : ''], "bg-white capitalize resizable-th"]),
                          style: _normalizeStyle(_ctx.columnStyle(presentColumn)),
                          onClick: ($event: any) => (_ctx.onHeaderClick(presentColumn))
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["flex", _ctx.getPaddingForColumn(presentColumn)])
                          }, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.getColumnLabel(presentColumn)), 1),
                            (presentColumn == 'framework_controlNo')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                              : (_ctx.getColumnLabel(presentColumn) != '')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(["sort cursor-pointer", _ctx.className == presentColumn ? _ctx.classSort : 'opacity-50'])
                                  }, null, 2))
                                : _createCommentVNode("", true)
                          ], 2),
                          _createElementVNode("span", {
                            class: "column-resize-handle",
                            onMousedown: _withModifiers(($event: any) => (_ctx.startColumnResize($event, presentColumn)), ["stop","prevent"])
                          }, null, 40, _hoisted_9)
                        ], 14, _hoisted_7))
                      }), 128))
                    ]),
                    (_ctx.visibility)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn, index) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: index,
                              class: _normalizeClass(_ctx.isCenterAlignedColumn(presentColumn) ? 'column-center' : ''),
                              style: _normalizeStyle(_ctx.columnStyle(presentColumn))
                            }, [
                              (_ctx.isColumnArrayPresent(presentColumn))
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 0,
                                    class: _normalizeClass([_ctx.filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect', "statusFilter"]),
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event)
                                  }, [
                                    _createElementVNode("option", {
                                      value: _ctx.filters.presentColumn,
                                      selected: "",
                                      hidden: "",
                                      disabled: ""
                                    }, "Select", 8, _hoisted_12),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDropdownOptionsForFilter(presentColumn), (option) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        class: "optionColors",
                                        key: option.id,
                                        value: option.id
                                      }, _toDisplayString(option.value), 9, _hoisted_13))
                                    }), 128))
                                  ], 10, _hoisted_11)), [
                                    [_vModelSelect, _ctx.filters[presentColumn]]
                                  ])
                                : _createCommentVNode("", true),
                              (presentColumn=='criticality')
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 1,
                                    class: _normalizeClass(_ctx.filters[presentColumn] == null ? 'inputboxstylingForSelect criticalitystyling' : 'stylingForInputboxstylingForSelect criticalitystyling'),
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event)
                                  }, [
                                    _createElementVNode("option", {
                                      value: _ctx.filters.presentColumn,
                                      selected: "",
                                      hidden: "",
                                      disabled: ""
                                    }, "Select", 8, _hoisted_15),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbProcessCriticality, (pair) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        class: "optionColors",
                                        key: pair,
                                        value: pair.value
                                      }, _toDisplayString(pair.key), 9, _hoisted_16))
                                    }), 128))
                                  ], 10, _hoisted_14)), [
                                    [_vModelSelect, _ctx.filters[presentColumn]]
                                  ])
                                : _createCommentVNode("", true),
                              (presentColumn=='tier')
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 2,
                                    class: _normalizeClass(_ctx.filters[presentColumn] == null ? 'inputboxstylingForSelect criticalitystyling' : 'stylingForInputboxstylingForSelect criticalitystyling'),
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event)
                                  }, [
                                    _createElementVNode("option", {
                                      value: _ctx.filters.presentColumn,
                                      selected: "",
                                      hidden: "",
                                      disabled: ""
                                    }, "Select", 8, _hoisted_18),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityOptions, (pair) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        class: "optionColors",
                                        key: pair,
                                        value: pair.label
                                      }, _toDisplayString(pair.label), 9, _hoisted_19))
                                    }), 128))
                                  ], 10, _hoisted_17)), [
                                    [_vModelSelect, _ctx.filters[presentColumn]]
                                  ])
                                : (_ctx.isFilterNotNecessary(presentColumn))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                                  : (presentColumn == 'taskId')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "searchForInputBoxStyling marginForIdInFilters",
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event),
                                          placeholder: "Search"
                                        }, null, 8, _hoisted_22), [
                                          [
                                            _vModelText,
                                            _ctx.filters[presentColumn],
                                            void 0,
                                            { trim: true }
                                          ]
                                        ])
                                      ]))
                                    : (presentColumn!='type' && presentColumn!='frequency'&& presentColumn!='taskstatus' && presentColumn!='criticality' && presentColumn!='SubTaskStatus')
                                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                          key: 5,
                                          type: "text",
                                          class: "searchForInputBoxStyling",
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event),
                                          placeholder: "Search"
                                        }, null, 8, _hoisted_23)), [
                                          [
                                            _vModelText,
                                            _ctx.filters[presentColumn],
                                            void 0,
                                            { trim: true }
                                          ]
                                        ])
                                      : _createCommentVNode("", true)
                            ], 6))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 4)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("table", {
                  class: "table-fit-card",
                  style: _normalizeStyle(_ctx.tableResizeStyle)
                }, [
                  (_ctx.loadData == true && _ctx.sortedData.length == 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_25, [
                        _createElementVNode("tr", _hoisted_26, [
                          _createElementVNode("td", {
                            class: "relative h-5",
                            colspan: _ctx.columnNames.size
                          }, [
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_dotsloader)
                            ])
                          ], 8, _hoisted_27)
                        ])
                      ]))
                    : (_ctx.sortedData.length == 0)
                      ? (_openBlock(), _createElementBlock("tbody", {
                          key: 1,
                          class: _normalizeClass(_ctx.pageData!=undefined && _ctx.pageData == 4 ? 'emptyFixed':'')
                        }, [
                          _createElementVNode("tr", _hoisted_29, [
                            _createElementVNode("td", {
                              class: "relative h-10",
                              colspan: _ctx.columnNames.size
                            }, [...(_cache[1] || (_cache[1] = [
                              _createElementVNode("div", { class: "flex justify-center" }, [
                                _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                              ], -1)
                            ]))], 8, _hoisted_30)
                          ])
                        ], 2))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_31, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (row, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: row,
                              class: "cursor-pointer rowHeight"
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: presentColumn,
                                  onMouseout: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doFalse())),
                                  onClick: ($event: any) => (_ctx.clickedOnTableRowData(row, index, presentColumn)),
                                  class: _normalizeClass(["cursor-pointer relative", [_ctx.getColumnHeadWidth(presentColumn), _ctx.isCenterAlignedColumn(presentColumn) ? 'column-center' : '']]),
                                  style: _normalizeStyle(_ctx.columnStyle(presentColumn))
                                }, [
                                  (_ctx.isColumnPresentForLabel(presentColumn))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["flex items-center justify-center rounded w-24 h-5", _ctx.bgColorForStatus(row[presentColumn])])
                                        }, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(_ctx.textColorForTemplateStatus(row[presentColumn]))
                                          }, _toDisplayString(_ctx.getStatusLabelFromColumn(row[presentColumn],presentColumn)), 3)
                                        ], 2)
                                      ]))
                                    : (presentColumn=='framework_controlNo')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                          (row[presentColumn] != undefined && row[presentColumn].length == 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString('N/A  N/A')))
                                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(row[presentColumn], (obj, index) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: index,
                                                  class: "flex py-1"
                                                }, [
                                                  ((obj.framework == undefined || obj.framework == null) && index<1)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString('N/A')))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(obj.framework), 1)),
                                                  ((obj.controls == undefined || (obj.controls.length == 1 && obj.controls[0]==null)) && index<1)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString('N/A')))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(obj.controls, (control) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            key: control,
                                                            class: "flex flex-wrap items-center pb-1"
                                                          }, [
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass([_ctx.getBorder(), "text-xs px-2 py-0.5 bg-white font-bold h-auto flex items-center"])
                                                            }, _toDisplayString(control), 3)
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                ]))
                                              }), 128))
                                        ]))
                                      : (presentColumn == 'criticality')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                            (row[presentColumn])
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular", _ctx.colorRiskBg(row[presentColumn])])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["table-ellipsisForValue", _ctx.colorRiskText(row[presentColumn])]),
                                                    style: {"white-space":"break-spaces"},
                                                    onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'label'))
                                                  }, _toDisplayString(_ctx.dbProcessCriticality.find((l) => {
                                                    return l.value == row[presentColumn];
                                                }).key), 43, _hoisted_41)
                                                ], 2))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_42, " - "))
                                          ]))
                                        : (presentColumn=='startDate'||presentColumn=='dueDate')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                              (row[presentColumn] != undefined || row[presentColumn] !=null)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_ctx.changeDateFormat(row[presentColumn])), 1))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_45, " - "))
                                            ]))
                                          : (presentColumn=='tier')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                _createElementVNode("div", null, _toDisplayString(row[presentColumn]), 1)
                                              ]))
                                            : (presentColumn=='frequency')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                  _createElementVNode("div", null, _toDisplayString(_ctx.getFrequency(row[presentColumn])), 1)
                                                ]))
                                              : (presentColumn=='deleteIcon')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center h-5", _ctx.isCenterAlignedColumn(presentColumn) ? 'justify-center' : 'justify-start'])
                                                    }, [
                                                      _createElementVNode("img", {
                                                        src: _imports_0,
                                                        class: "h-5 w-5 cursor-pointer",
                                                        onClick: ($event: any) => (_ctx.clickedOnDeleteButton(row))
                                                      }, null, 8, _hoisted_49)
                                                    ], 2)
                                                  ]))
                                                : (presentColumn=='type')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                      (row[presentColumn] == 20501)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, "Task"))
                                                        : (row[presentColumn] == 20502)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, "Sub-Task"))
                                                          : (row[presentColumn] == 20503|| row[presentColumn] == 20504)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, "Task"))
                                                            : (row[presentColumn] == '')
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_54, "-"))
                                                              : _createCommentVNode("", true)
                                                    ]))
                                                  : (presentColumn=='title')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                        _createElementVNode("div", {
                                                          class: "title-wrap",
                                                          onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                                        }, _toDisplayString(row[presentColumn]), 41, _hoisted_56)
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                        _createElementVNode("div", _hoisted_58, [
                                                          _createElementVNode("div", {
                                                            onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text')),
                                                            class: _normalizeClass(presentColumn == 'Templates'?'pl-9':'')
                                                          }, _toDisplayString(row[presentColumn]), 43, _hoisted_59)
                                                        ])
                                                      ]))
                                ], 46, _hoisted_32))
                              }), 128))
                            ]))
                          }), 128))
                        ]))
                ], 4)
              ])
            ]),
            _createVNode(_component_pagination, {
              dynamicPagination: _ctx.dynamicPagination,
              onCurrentPageUpdate: _ctx.paginationUpdations,
              sortedData: _ctx.sortedData,
              pageData: _ctx.pageData
            }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData", "pageData"])
          ], 2)
        ])
      ]))
}